<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="ppm.plural"> </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder [dataTableObject]="dataTableObject" [totalRecords]="totalRecords" [datas]="data || []"
      [loading]="loading"></sm-data-table-builder>
  </div>
  <sm-dialog #dialog [dialog]="ppmDialog"></sm-dialog>
</div>